import { Predicates } from "libraries/predicates/predicates";
import {
  ICompositionComponent,
  IMpnComposition,
} from "../../../../types/data.interface";
import { ExpandableSection } from "../expandable-section";
import { CompositionCheckbox } from "../mpn-composition-modal";
import { CompositionType } from "../mpn-composition-modal/AddMpnCompositionModal";
import ComponentsGroupTreeNode from "./ComponentsGroupTreeNode";
import TreeActionsGroup from "./TreeActionsGroup";

const MpnTreeNode = ({
  id,
  mpn,
  isRoot,
  isSummaryPage,
  isMainPage,
  isPipPage,
  addActionHandler,
  handleRemoveNode,
  openEditModal,

  shouldIncludeSku,
  canAddSku,
  manageSkuInclusion,
  manageComponentInclusion,
  assertComponentIsIncluded,
}: {
  id: string;
  mpn: IMpnComposition;
  isRoot: boolean;
  isSummaryPage: boolean;
  isMainPage: boolean;
  isPipPage: boolean;
  addActionHandler?: (node_id: number) => void;
  handleRemoveNode?: (
    node_id: number,
    compositionType: CompositionType,
  ) => void;
  openEditModal?: (
    compositionEditType: CompositionType,
    compositionEditObject: ICompositionComponent | IMpnComposition,
  ) => void;

  shouldIncludeSku: boolean;
  canAddSku?: boolean;
  manageSkuInclusion: any;
  manageComponentInclusion: any;
  assertComponentIsIncluded: any;
}) => {
  return (
    <>
      {mpn?.mpns?.length > 0 &&
        mpn?.mpns?.map((mpn:any) => {
          return (
            <li
              className={`d-flex justify-content-between gap-4 ${
                !isRoot && !isMainPage && !isSummaryPage
                  ? "remove-tree-link"
                  : ""
              }`}
            >
              {isRoot && !isMainPage && !isSummaryPage && (
                <CompositionCheckbox
                  checkedChangeHandler={manageSkuInclusion}
                  nodeId={mpn.node_id ?? -1}
                  isChecked={shouldIncludeSku}
                  isDisabled={
                    Predicates.isNotNullAndNotUndefined(canAddSku)
                      ? !canAddSku
                      : false
                  }
                />
              )}

              <div className="w-100">
                <ExpandableSection
                  sectionId={id}
                  title={`MPN 11 ${mpn?.id.padStart(6, "0")} - ${mpn?.name}`}
                  expandedByDefault={true}
                >
                  <ul>
                    <>
                      {mpn.molded_components.length > 0 && (
                        <ComponentsGroupTreeNode
                          id={`${id}_composition_molded`}
                          type={"Molded"}
                          isRoot={false}
                          isSummaryPage={isSummaryPage}
                          isMainPage={isMainPage}
                          isPipPage={isPipPage}
                          components={mpn.molded_components}
                          shouldIncludeSku={shouldIncludeSku}
                          // addActionHandler={addActionHandler}
                          openEditModal={openEditModal}
                          handleRemoveNode={handleRemoveNode}
                          manageComponentInclusion={manageComponentInclusion}
                          assertComponentIsIncluded={assertComponentIsIncluded}
                          tccComposition={[]}
                        />
                      )}

                      {mpn.non_molded_components.length > 0 && (
                        <ComponentsGroupTreeNode
                          id={`${id}_composition_non_molded`}
                          type={"NonMolded"}
                          isRoot={false}
                          isSummaryPage={isSummaryPage}
                          isMainPage={isMainPage}
                          isPipPage={isPipPage}
                          // addActionHandler={addActionHandler}
                          openEditModal={openEditModal}
                          handleRemoveNode={handleRemoveNode}
                          components={mpn.non_molded_components}
                          shouldIncludeSku={shouldIncludeSku}
                          manageComponentInclusion={manageComponentInclusion}
                          assertComponentIsIncluded={assertComponentIsIncluded}
                          tccComposition={[]}
                        />
                      )}
                    </>
                  </ul>
                </ExpandableSection>
              </div>

              {!isSummaryPage &&
                isRoot &&
                openEditModal &&
                handleRemoveNode &&
                addActionHandler && (
                  <TreeActionsGroup
                    node={mpn}
                    isMainPage={isMainPage}
                    compositionType="mpn"
                    addActionHandler={addActionHandler}
                    editActionHandler={openEditModal}
                    removeActionHandler={handleRemoveNode}
                  />
                )}
            </li>
          );
        })}

      {mpn?.skus?.length > 0 &&
        mpn?.skus?.map((sku) => {
          return (
            <li
              className={`d-flex justify-content-between gap-4 ${
                !isRoot && !isMainPage && !isSummaryPage
                  ? "remove-tree-link"
                  : ""
              }`}
            >
              {isRoot && !isMainPage && !isSummaryPage && (
                <CompositionCheckbox
                  checkedChangeHandler={manageSkuInclusion}
                  nodeId={sku.node_id ?? -1}
                  isChecked={shouldIncludeSku}
                  isDisabled={
                    Predicates.isNotNullAndNotUndefined(canAddSku)
                      ? !canAddSku
                      : false
                  }
                />
              )}

              <div className="w-100">
                <ExpandableSection
                  sectionId={id}
                  title={`MPN 11 ${sku?.id.padStart(6, "0")} - ${sku?.name}`}
                  expandedByDefault={true}
                >
                  <ul>
                    <>
                      {sku.molded_components.length > 0 && (
                        <ComponentsGroupTreeNode
                          id={`${id}_molded`}
                          type={"Molded"}
                          isRoot={false}
                          isSummaryPage={isSummaryPage}
                          isMainPage={isMainPage}
                          isPipPage={isPipPage}
                          // addActionHandler={addActionHandler}
                          openEditModal={openEditModal}
                          handleRemoveNode={handleRemoveNode}
                          components={sku.molded_components}
                          shouldIncludeSku={shouldIncludeSku}
                          manageComponentInclusion={manageComponentInclusion}
                          assertComponentIsIncluded={assertComponentIsIncluded}
                          tccComposition={[]}
                        />
                      )}

                      {sku.non_molded_components.length > 0 && (
                        <ComponentsGroupTreeNode
                          id={`${id}_non_molded`}
                          type={"NonMolded"}
                          isRoot={false}
                          isSummaryPage={isSummaryPage}
                          isMainPage={isMainPage}
                          isPipPage={isPipPage}
                          // addActionHandler={addActionHandler}
                          openEditModal={openEditModal}
                          handleRemoveNode={handleRemoveNode}
                          components={sku.non_molded_components}
                          shouldIncludeSku={shouldIncludeSku}
                          manageComponentInclusion={manageComponentInclusion}
                          assertComponentIsIncluded={assertComponentIsIncluded}
                          tccComposition={[]}
                        />
                      )}
                    </>
                  </ul>
                </ExpandableSection>

                {!isSummaryPage &&
                  isRoot &&
                  openEditModal &&
                  handleRemoveNode &&
                  addActionHandler && (
                    <TreeActionsGroup
                      node={sku as IMpnComposition}
                      isMainPage={isMainPage}
                      compositionType="mpn"
                      addActionHandler={addActionHandler}
                      editActionHandler={openEditModal}
                      removeActionHandler={handleRemoveNode}
                    />
                  )}
              </div>
            </li>
          );
        })}

      {(mpn?.molded_components?.length > 0 ||
        mpn?.non_molded_components?.length > 0) && (
        // <li
        //   className={`d-flex justify-content-between gap-4 remove-tree-link`}
        // >
        //   <div className="w-100">
            <>
              {mpn.molded_components.length > 0 && (
                <ComponentsGroupTreeNode
                  id={id}
                  type={"Molded"}
                  isRoot={false}
                  isSummaryPage={isSummaryPage}
                  isMainPage={isMainPage}
                  isPipPage={isPipPage}
                  addActionHandler={addActionHandler}
                  openEditModal={openEditModal}
                  handleRemoveNode={handleRemoveNode}
                  components={mpn.molded_components}
                  shouldIncludeSku={shouldIncludeSku}
                  manageComponentInclusion={manageComponentInclusion}
                  assertComponentIsIncluded={assertComponentIsIncluded}
                  tccComposition={[]}
                />
              )}

              {mpn.non_molded_components.length > 0 && (
                <ComponentsGroupTreeNode
                  id={id}
                  type={"NonMolded"}
                  isRoot={false}
                  isSummaryPage={isSummaryPage}
                  isMainPage={isMainPage}
                  isPipPage={isPipPage}
                  addActionHandler={addActionHandler}
                  openEditModal={openEditModal}
                  handleRemoveNode={handleRemoveNode}
                  components={mpn.non_molded_components}
                  shouldIncludeSku={shouldIncludeSku}
                  manageComponentInclusion={manageComponentInclusion}
                  assertComponentIsIncluded={assertComponentIsIncluded}
                  tccComposition={[]}
                />
              )}
            </>
        //   </div>
        // </li>
      )}
    </>
  );
};

export default MpnTreeNode;
